export interface ComicChapter {
  id: number;
  title: string;
  updateDate: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: 'hanman' | 'riman' | 'guoman';
  status: string;
  rating: number;
  views: number;
  updateDate: string;
  chapters: ComicChapter[];
  tags: string[];
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '我独自升级',
    author: 'Chugong / Dubu',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20hunter%20with%20dark%20aura%20standing%20in%20a%20dungeon%2C%20dramatic%20lighting%2C%20cool%20tone%2C%20modern%20webtoon%20art%20style%2C%20detailed%20character%20design%2C%20epic%20atmosphere%2C%20clean%20composition%2C%20manga%20cover%20quality&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '十年前，世界上突然出现了连接异次元的"门"，而其中觉醒的人类被称为"猎人"。程肖宇是最低等级的E级猎人，被嘲笑为"人类最弱兵器"。在一次几乎全军覆没的地下城探险中，他获得了神秘系统的力量，成为了唯一能够"升级"的猎人。从此，他从最弱一步步走向最强，开启了逆天改命的传奇之路。',
    category: 'hanman',
    status: '连载中',
    rating: 4.9,
    views: 12850000,
    updateDate: '2026-08-03',
    tags: ['热血', '战斗', '系统流', '逆袭'],
    chapters: [
      { id: 1, title: '第1话 最弱的猎人', updateDate: '2025-01-15' },
      { id: 2, title: '第2话 神秘的系统', updateDate: '2025-01-22' },
      { id: 3, title: '第3话 每日任务', updateDate: '2025-01-29' },
      { id: 179, title: '第179话 最终之战', updateDate: '2026-07-30' },
    ],
  },
  {
    id: 2,
    title: '剑尊归来',
    author: 'LEE Jin-seok',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20swordsman%20in%20traditional%20martial%20arts%20robe%20holding%20a%20glowing%20sword%2C%20ancient%20Chinese%20palace%20background%2C%20murim%20aesthetic%2C%20dramatic%20dynamic%20pose%2C%20detailed%20ink%20wash%20painting%20style%2C%20epic%20wuxia%20vibe&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '剑尊明虎，江湖第一剑客，却被最信任的弟子背叛而陨落。百年之后，他重生在一个武道没落的时代。昔日的绝世剑法，在这个枪炮为王的时代是否还能重现辉煌？明虎带着前世的记忆与剑法，重新踏上武道巅峰之路。江湖虽远，剑心不灭！',
    category: 'hanman',
    status: '连载中',
    rating: 4.8,
    views: 9620000,
    updateDate: '2026-08-02',
    tags: ['武侠', '重生', '战斗', '江湖'],
    chapters: [
      { id: 1, title: '第1话 陨落', updateDate: '2024-06-10' },
      { id: 2, title: '第2话 百年之后', updateDate: '2024-06-17' },
      { id: 156, title: '第156话 剑意通天', updateDate: '2026-07-28' },
    ],
  },
  {
    id: 3,
    title: '咒术回战',
    author: '芥见下下',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20sorcerer%20with%20spiky%20hair%20surrounded%20by%20cursed%20energy%20blue%20flames%2C%20dark%20supernatural%20atmosphere%2C%20shonen%20jump%20aesthetic%2C%20dynamic%20action%20pose%2C%20detailed%20line%20art%2C%20intense%20expression&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '高中生虎杖悠仁在偶然的机会下吞下了被封印的特级咒物——两面宿傩的手指，从此踏入了咒术师的世界。为了收集散落在各地的宿傩手指，悠仁加入了东京都立咒术高等专门学校，与伙伴们一起对抗诅咒。一场关乎人类命运的咒术大战就此展开！',
    category: 'riman',
    status: '连载中',
    rating: 4.7,
    views: 15680000,
    updateDate: '2026-08-04',
    tags: ['热血', '战斗', '超能力', '黑暗'],
    chapters: [
      { id: 1, title: '第1话 两面宿傩', updateDate: '2018-03-05' },
      { id: 2, title: '第2话 秘密处刑', updateDate: '2018-03-12' },
      { id: 271, title: '第271话 终焉', updateDate: '2026-08-01' },
    ],
  },
  {
    id: 4,
    title: '间谍过家家',
    author: '远藤达哉',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20family%20of%20three%20with%20a%20gentleman%20in%20suit%20a%20beautiful%20woman%20and%20a%20cute%20little%20girl%20with%20pink%20hair%2C%20warm%20comedy%20vibe%2C%20clean%20art%20style%2C%20light%20hearted%20atmosphere%2C%20spy%20family%20theme&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '为了执行秘密任务，顶级间谍"黄昏"需要组建一个临时家庭。他收养了拥有读心能力的少女阿尼亚，与杀手"睡美人"约尔假结婚。三个人各自怀着秘密，却组成了一个温馨而搞笑的家庭。当间谍、杀手和超能力少女聚在一起，日常比任务更精彩！',
    category: 'riman',
    status: '连载中',
    rating: 4.8,
    views: 11230000,
    updateDate: '2026-08-03',
    tags: ['喜剧', '温馨', '间谍', '家庭'],
    chapters: [
      { id: 1, title: '第1话 MISSION:1', updateDate: '2019-03-25' },
      { id: 2, title: '第2话 MISSION:2', updateDate: '2019-04-01' },
      { id: 103, title: '第103话', updateDate: '2026-07-28' },
    ],
  },
  {
    id: 5,
    title: '一人之下',
    author: '米二',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20of%20a%20young%20man%20with%20supernatural%20qi%20energy%20surrounding%20him%2C%20modern%20urban%20setting%20with%20traditional%20Taoist%20elements%2C%20dynamic%20martial%20arts%20pose%2C%20detailed%20Chinese%20ink%20style%2C%20mysterious%20atmosphere&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '普通大学生张楚岚在爷爷坟墓被盗后，意外卷入了异人世界的纷争。原来这个世界上存在着拥有超能力的"异人"，而张楚岚体内隐藏着惊人的秘密。为了寻找真相，他踏上了异人之路，结识了冯宝宝等伙伴，揭开了一个跨越百年的惊天阴谋。',
    category: 'guoman',
    status: '连载中',
    rating: 4.6,
    views: 8950000,
    updateDate: '2026-08-01',
    tags: ['奇幻', '战斗', '都市', '道家'],
    chapters: [
      { id: 1, title: '第1话 爷爷的坟墓', updateDate: '2015-02-26' },
      { id: 2, title: '第2话 异人', updateDate: '2015-03-05' },
      { id: 632, title: '第632话', updateDate: '2026-07-25' },
    ],
  },
  {
    id: 6,
    title: '全职高手',
    author: '蝴蝶蓝 / 常盘勇者',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20of%20a%20cool%20esports%20player%20holding%20a%20gaming%20mouse%20with%20glowing%20digital%20effects%2C%20cyberpunk%20gaming%20aesthetic%2C%20professional%20gamer%20vibe%2C%20dynamic%20composition%2C%20clean%20modern%20art%20style&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '被誉为"荣耀教科书"的顶尖电竞选手叶修，因不愿配合商业化而被俱乐部驱逐。他来到一家网吧当网管，用全新的角色"君莫笑"重新开始了荣耀之旅。从零开始，他带着一把自制武器千机伞，在荣耀第十区掀起了一场风暴。这才是真正的——全职高手！',
    category: 'guoman',
    status: '已完结',
    rating: 4.9,
    views: 20100000,
    updateDate: '2026-07-15',
    tags: ['电竞', '热血', '逆袭', '竞技'],
    chapters: [
      { id: 1, title: '第1话 被驱逐的高手', updateDate: '2017-04-07' },
      { id: 2, title: '第2话 君莫笑', updateDate: '2017-04-14' },
      { id: 326, title: '第326话 荣耀之巅（终）', updateDate: '2025-12-20' },
    ],
  },
  {
    id: 7,
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20young%20demon%20slayer%20with%20green%20checkered%20haori%20holding%20a%20nichirin%20katana%2C%20taisho%20era%20Japan%20setting%2C%20water%20breathing%20effects%2C%20dramatic%20and%20emotional%20atmosphere%2C%20detailed%20hand%20drawn%20art&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '大正时代的日本，少年灶门炭治郎一家惨遭鬼的杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了让妹妹恢复人类，炭治郎踏上了成为鬼杀队剑士的道路。在残酷的战斗中，他逐渐揭开了鬼舞辻无惨的千年之谜。这是一部关于家人、羁绊与不屈意志的动人故事。',
    category: 'riman',
    status: '已完结',
    rating: 4.9,
    views: 18900000,
    updateDate: '2026-06-20',
    tags: ['热血', '战斗', '温情', '和风'],
    chapters: [
      { id: 1, title: '第1话 残酷', updateDate: '2016-02-15' },
      { id: 2, title: '第2话 培育者', updateDate: '2016-02-22' },
      { id: 205, title: '第205话 闪耀的生命（终）', updateDate: '2020-05-18' },
    ],
  },
  {
    id: 8,
    title: '镖人',
    author: '许先哲',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20of%20a%20rugged%20swordsman%20in%20ancient%20Chinese%20desert%20setting%2C%20western%20region%20silk%20road%20aesthetic%2C%20detailed%20ink%20brush%20style%2C%20gritty%20and%20realistic%20tone%2C%20dynamic%20action%20scene%2C%20dust%20and%20wind%20effects&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '大业三年，隋朝。一个武功高强的神秘镖客刀马，带着小孩小七行走于西域大漠之中。他接下了一趟护送任务，却不知道这趟镖将把他卷入一个巨大的阴谋漩涡。朝廷、江湖、西域势力，各方人马汇聚，一场血雨腥风的杀戮即将展开。国产漫画的巅峰之作！',
    category: 'guoman',
    status: '连载中',
    rating: 4.7,
    views: 5560000,
    updateDate: '2026-07-28',
    tags: ['武侠', '历史', '硬派', '江湖'],
    chapters: [
      { id: 1, title: '第1话 镖客', updateDate: '2015-07-01' },
      { id: 2, title: '第2话 大漠', updateDate: '2015-08-01' },
      { id: 113, title: '第113话', updateDate: '2026-07-20' },
    ],
  },
  {
    id: 9,
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20princess%20with%20long%20blonde%20hair%20in%20an%20elegant%20European%20royal%20dress%2C%20romantic%20fantasy%20palace%20background%2C%20soft%20pastel%20colors%2C%20shojo%20manga%20aesthetic%2C%20sparkling%20magical%20atmosphere&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '醒来之后发现自己变成了小说中的公主——一个注定要被亲生父亲处死的悲剧角色！为了改变自己的命运，阿塔纳西娅开始努力在父皇面前刷存在感。从冷漠的暴君父亲到宠爱女儿的傻爸爸，这条逆天改命之路充满欢笑与泪水。',
    category: 'hanman',
    status: '已完结',
    rating: 4.7,
    views: 7820000,
    updateDate: '2026-05-10',
    tags: ['恋爱', '穿越', '宫廷', '逆袭'],
    chapters: [
      { id: 1, title: '第1话 觉醒', updateDate: '2017-12-20' },
      { id: 2, title: '第2话 父皇', updateDate: '2017-12-27' },
      { id: 125, title: '第125话 从此以后（终）', updateDate: '2022-06-15' },
    ],
  },
  {
    id: 10,
    title: '排球少年！！',
    author: '古馆春一',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20high%20school%20volleyball%20player%20jumping%20high%20to%20spike%20the%20ball%2C%20orange%20hair%2C%20dynamic%20sports%20action%2C%20gymnasium%20background%2C%20energetic%20shonen%20style%2C%20passionate%20expression%2C%20clean%20line%20art&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '身材矮小的日向翔阳在初中时被排球吸引，虽然第一次正式比赛就惨败，但他没有放弃。进入乌野高中后，他与曾经的对手影山飞雄成为了队友。两个天才的相遇，点燃了乌野高中的排球之魂！朝着全国大赛的目标，飞翔吧！',
    category: 'riman',
    status: '已完结',
    rating: 4.8,
    views: 14500000,
    updateDate: '2026-04-05',
    tags: ['运动', '热血', '青春', '竞技'],
    chapters: [
      { id: 1, title: '第1话 结束与开始', updateDate: '2012-02-20' },
      { id: 2, title: '第2话 乌野高中排球部', updateDate: '2012-02-27' },
      { id: 402, title: '第402话 挑战者（终）', updateDate: '2020-07-20' },
    ],
  },
  {
    id: 11,
    title: '女神降临',
    author: 'Yaongyi',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20girl%20with%20perfect%20makeup%20looking%20in%20a%20mirror%2C%20before%20and%20after%20transformation%20concept%2C%20modern%20school%20life%2C%20romantic%20comedy%20vibe%2C%20trendy%20fashion%2C%20clean%20webtoon%20style&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '因为长相平凡而被校园霸凌的林周京，通过自学化妆技术实现了惊人的变身，成为了校园里的"女神"。然而她必须在素颜和化妆后的自己之间小心翼翼地生活。当两个顶级帅哥同时走进她的生活，这个关于外貌、自信与真爱的故事就此展开。',
    category: 'hanman',
    status: '已完结',
    rating: 4.5,
    views: 16700000,
    updateDate: '2026-03-18',
    tags: ['恋爱', '校园', '美妆', '成长'],
    chapters: [
      { id: 1, title: '第1话 素颜的秘密', updateDate: '2018-04-02' },
      { id: 2, title: '第2话 化妆的力量', updateDate: '2018-04-09' },
      { id: 228, title: '第228话 真正的女神（终）', updateDate: '2023-09-10' },
    ],
  },
  {
    id: 12,
    title: '狐妖小红娘',
    author: '小新',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20of%20a%20beautiful%20fox%20spirit%20girl%20with%20red%20hair%20and%20fox%20ears%20in%20traditional%20Chinese%20hanfu%2C%20romantic%20fantasy%20ancient%20Chinese%20setting%2C%20peach%20blossom%20trees%2C%20soft%20magical%20glow%2C%20elegant%20and%20dreamy%20art%20style&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '在一个人与妖共存的世界里，涂山狐妖一族以红娘为职业，为前世恋人牵线续缘。涂山苏苏是一只呆萌的小狐妖，梦想成为最优秀的红线仙。她与道士白月初相遇后，两人携手完成一个个续缘任务，也在过程中发现了自己前世今生的秘密。',
    category: 'guoman',
    status: '连载中',
    rating: 4.6,
    views: 7230000,
    updateDate: '2026-08-02',
    tags: ['奇幻', '恋爱', '转世', '仙侠'],
    chapters: [
      { id: 1, title: '第1话 狐妖小红娘', updateDate: '2012-05-14' },
      { id: 2, title: '第2话 红线仙', updateDate: '2012-05-21' },
      { id: 568, title: '第568话', updateDate: '2026-07-26' },
    ],
  },
];

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'hanman', name: '韩漫', icon: 'ri-knife-line' },
  { slug: 'riman', name: '日漫', icon: 'ri-sun-line' },
  { slug: 'guoman', name: '国漫', icon: 'ri-china-railway-line' },
];